import { Component, OnInit } from "@angular/core";
import { Breadcrumb } from "src/app/interfaces/bread-crumb";
import { TranslateService } from "@ngx-translate/core";
import { ApplicationService } from "src/app/services/application.service";

@Component({
    selector: "app-news-page",
    templateUrl: "./news-page.component.html",
    styleUrls: ["./news-page.component.scss"],
    standalone: false
})
export class NewsPageComponent implements OnInit {
  breadcrumbs: Breadcrumb[];
  constructor(
    private translateService: TranslateService,
    private applicationService: ApplicationService
  ) {}

  ngOnInit() {
    this.setBreadcrumbs();
  }

  setBreadcrumbs() {
    // Set breadcrumbs
    this.breadcrumbs = [
      new Breadcrumb(
        this.translateService.instant("HOME"),
        this.applicationService.getSelectCompanyGroupCode() + "/home"
      ),
      new Breadcrumb(this.translateService.instant("ACTUAL"), "#"),
      new Breadcrumb(this.translateService.instant("NEWS"), "#")

    ];
  }
}
